import { render, staticRenderFns } from "./shop-category-grade.vue?vue&type=template&id=2866b080&"
import script from "./shop-category-grade.vue?vue&type=script&lang=js&"
export * from "./shop-category-grade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports